import React from 'react';
import "./Historia.css";


function Historia() {
  return (

    <div className="historia-container">
      <h1>Quiénes somos</h1>
      <p>
        Todo comenzó en el año 2022 en la ciudad de San Carlos de Bariloche. 
        Luego de muchos años de ser jugadores, profesores 
        y árbitros de hockey en diferentes clubes, decidimos formar “HUEMULES HOCKEY CLUB”.
      </p>
      <p>
         El principal objetivo de nuestro club es que todos puedan jugar y aprender este 
        deporte que tanto nos apasiona. Apuntamos a participar en diversos torneos y formar 
        todas las categorías posibles, para que nadie se quede afuera. Siempre priorizando 
        el disfrute, la promoción de la actividad física —tan beneficiosa para el cuerpo y 
        la mente—, el compartir con otros, el juego en equipo, la empatía y el compromiso 
        de pertenecer a un grupo con un mismo objetivo. 
      </p>
      <p>
        ¡¡¡Y lo más importante: jugar al hockey, que es lo que más nos gusta, nos apasiona 
        y nos hace tan felices!!!
      </p>
      <p>
        El nombre “Huemules” surgió pensando en la ciudad tan hermosa en la que vivimos, 
        en lo lindo de la naturaleza que nos rodea. Así surgió la idea de elegir un animal 
        que nos represente en la Patagonia, y el Huemul fue el que recibió más votos.
      </p>
      <p>
        Durante sus primeros dos años, el club funcionó en la Escuela Primaria N.º 187.  
        Poco a poco fuimos creciendo, superando desafíos y sumando jugadores, entrenadores y 
        familias a este sueño.  
        Hoy somos una gran familia que sigue avanzando con pasión y compromiso. Actualmente 
        entrenamos en el Gimnasio New Lawn y en el gimnasio de la Escuela Secundaria N.º 99.
      </p>
      <p>En la actualidad, participamos en el torneo oficial de la Asociación de Hockey Bariloche 
        y Lagos del Sur, en las categorias damas, caballeros e inferiores.</p>
      <h2>¡Vení y sumate a jugar, aprender y competir con nosotros!</h2>
    </div>

  );
}

export default Historia;